/** Client *initial* state only — S->C 17 overwrites `moveSpeed`, `maxHealth`, `firingRange`, `damage` and `maxDrones` within ~200 ms. */
export const MAP_WIDTH = 5000;
export const MAP_HEIGHT = 5000;

export const BASE_START_HEALTH = 7500;

export const BASE_ORBIT_RADIUS = 2000;

export const BASE_ROTATION_PERIOD_MS = 45000;

export const PLAYER_BASELINE = {
  moveSpeed: 300,
  maxHealth: 100,
  firingRange: 650,
  damage: 10,
  maxDrones: 5,
} as const;

export const ABILITY_RADIUS = {
  heal: 300,
  scrap: 300,
  damage: 700,
  selfDamage: 500,
  controlPoint: 500,
} as const;

export const MAX_LEADERBOARD_ENTRIES = 10;

export const SCRAP_PICKUP_RADIUS = 20;

export const PI_IS_MATH_PI_NOT_THE_LEGACY_LITERAL = true;

export const MAX_NAME_CHARS = 35;

export const UNNAMED_NAME = '[Unnamed]';

export const NAME_REQUEST_RETRY_MS = 4000;

export const WORLD_PICKER = {
  worldCount: 5,
  bucketCount: 4,
  bucketLabels: ['Empty', 'Quiet', 'Busy', 'Full'] as const,
} as const;
